import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const includes = ['Fundamentos para encontrar productos ganadores y ofertas irresistibles.', 'Armado de marca desde cero: identidad, posicionamiento y confianza.', 'Creativos publicitarios con IA y edición de video.', 'Cómo encontrar proveedores reales y confiables.', 'Meta Ads desde cero: lanzamientos, testeos y campañas efectivas.', 'Escalado y análisis de métricas para maximizar ROAS.', 'Herramientas exclusivas y plantillas de gestión.'];
export function WhatsIncluded() {
  return <section className="py-24 px-6 bg-brand-darker relative border-y border-brand-border" data-id="element-114">
      <div className="max-w-4xl mx-auto" data-id="element-115">
        <div className="text-center mb-16" data-id="element-116">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-5xl font-bold mb-6 leading-tight" data-id="element-117">
            Una formación para construir un e-commerce real,{' '}
            <span className="gold-gradient-text" data-id="element-118">
              no para llenarte de teoría.
            </span>
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-lg text-brand-muted max-w-2xl mx-auto" data-id="element-119">
            Vas a aprender qué hacer, en qué orden y cómo avanzar sin perder
            meses probando sola.
          </motion.p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-brand-card border border-brand-gold/20 rounded-3xl p-8 md:p-12 mb-12 gold-border-glow" data-id="element-120">
          <div className="space-y-6" data-id="element-121">
            {includes.map((item, i) => <div key={i} className="flex items-start gap-4" data-id="element-122">
                <div className="w-6 h-6 rounded-full bg-brand-gold/10 flex items-center justify-center shrink-0 mt-1" data-id="element-123">
                  <Check className="w-4 h-4 text-brand-gold" data-id="element-124" />
                </div>
                <p className="text-lg text-brand-text/90" data-id="element-125">{item}</p>
              </div>)}
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="space-y-6 text-center max-w-3xl mx-auto" data-id="element-126">
          <p className="text-brand-muted text-lg" data-id="element-127">
            No necesitás tener todo el día libre para empezar. Necesitás una
            guía clara que te diga qué hacer, en qué orden y cómo avanzar sin
            perder tiempo.
          </p>
          <p className="text-brand-muted text-lg" data-id="element-128">
            En esta mentoría aprendés a crear tu tienda online, trabajar tu
            marca, generar contenido con IA, lanzar anuncios, leer métricas y
            aplicar estrategias para vender más por cada compra.
          </p>
          <p className="text-brand-text text-lg font-medium" data-id="element-129">
            Todo bajado a la práctica, para que puedas construir tu e-commerce
            incluso con una rutina ocupada.
          </p>

          <div className="pt-8" data-id="element-130">
            <p className="text-2xl font-bold gold-gradient-text" data-id="element-131">
              “No necesitás más tiempo. Necesitás dejar de perderlo
              improvisando.”
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}